import { useQueryClient } from '@tanstack/react-query';

import { invalidatePath } from '@/lib/queryCache';

/** После исправления: журнал, остатки, партии и отгрузки показывают новое состояние. */
export function useCorrectionRefresh() {
  const queryClient = useQueryClient();
  return () =>
    Promise.all(
      ['/api/v1/audit', '/api/v1/stock', '/api/v1/batches', '/api/v1/shipments'].map((p) =>
        invalidatePath(queryClient, p),
      ),
    );
}
